import { render, staticRenderFns } from "./updateuser.vue?vue&type=template&id=9f3882d2"
import script from "./updateuser.vue?vue&type=script&lang=js"
export * from "./updateuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports